"use strict";
var Persona_Props_1 = require('./Persona.Props');
exports.PERSONA_SIZE = (_a = {},
    _a[Persona_Props_1.PersonaSize.tiny] = 'ms-Persona--tiny',
    _a[Persona_Props_1.PersonaSize.extraSmall] = 'ms-Persona--xs',
    _a[Persona_Props_1.PersonaSize.small] = 'ms-Persona--sm',
    _a[Persona_Props_1.PersonaSize.regular] = '',
    _a[Persona_Props_1.PersonaSize.large] = 'ms-Persona--lg',
    _a[Persona_Props_1.PersonaSize.extraLarge] = 'ms-Persona--xl',
    _a
);
exports.PERSONA_PRESENCE = (_b = {},
    _b[Persona_Props_1.PersonaPresence.offline] = 'ms-Persona--offline',
    _b[Persona_Props_1.PersonaPresence.online] = 'ms-Persona--online',
    _b[Persona_Props_1.PersonaPresence.away] = 'ms-Persona--away',
    _b[Persona_Props_1.PersonaPresence.dnd] = 'ms-Persona--dnd',
    _b[Persona_Props_1.PersonaPresence.blocked] = 'ms-Persona--blocked',
    _b[Persona_Props_1.PersonaPresence.busy] = 'ms-Persona--busy',
    _b
);
exports.PERSONA_INITIALS_COLOR = (_c = {},
    _c[Persona_Props_1.PersonaInitialsColor.lightBlue] = 'ms-Persona-initials--lightBlue',
    _c[Persona_Props_1.PersonaInitialsColor.blue] = 'ms-Persona-initials--blue',
    _c[Persona_Props_1.PersonaInitialsColor.darkBlue] = 'ms-Persona-initials--darkBlue',
    _c[Persona_Props_1.PersonaInitialsColor.teal] = 'ms-Persona-initials--teal',
    _c[Persona_Props_1.PersonaInitialsColor.lightGreen] = 'ms-Persona-initials--lightGreen',
    _c[Persona_Props_1.PersonaInitialsColor.green] = 'ms-Persona-initials--green',
    _c[Persona_Props_1.PersonaInitialsColor.darkGreen] = 'ms-Persona-initials--darkGreen',
    _c[Persona_Props_1.PersonaInitialsColor.lightPink] = 'ms-Persona-initials--lightPink',
    _c[Persona_Props_1.PersonaInitialsColor.pink] = 'ms-Persona-initials--pink',
    _c[Persona_Props_1.PersonaInitialsColor.magenta] = 'ms-Persona-initials--magenta',
    _c[Persona_Props_1.PersonaInitialsColor.purple] = 'ms-Persona-initials--purple',
    _c[Persona_Props_1.PersonaInitialsColor.black] = 'ms-Persona-initials--black',
    _c[Persona_Props_1.PersonaInitialsColor.orange] = 'ms-Persona-initials--orange',
    _c[Persona_Props_1.PersonaInitialsColor.red] = 'ms-Persona-initials--red',
    _c[Persona_Props_1.PersonaInitialsColor.darkRed] = 'ms-Persona-initials--darkRed',
    _c
);
var _a, _b, _c;

//# sourceMappingURL=PersonaConsts.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/Persona/PersonaConsts.js
 ** module id = 176
 ** module chunks = 0
 **/